import { takeEvery, fork, put, all, call } from "redux-saga/effects"
import axios from "axios";

// Login Redux States
import { EDIT_PROFILE } from "./actionTypes"
import { profileSuccess, profileError } from "./actions"

function* editProfile({ payload: { user } }) {
  try {
    const token = localStorage.getItem("authToken");
    const response = yield call(
      axios.post,
      process.env.REACT_APP_WEB_APP_URL + "/api/web/update-profile",
      user, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    }
    );

    if (response.status == 200) {
      localStorage.setItem("authUser", JSON.stringify(response?.data?.data));
      yield put(profileSuccess(response.data?.message));
    } else {
      yield put(profileError(response.data?.error));
    }

  } catch (error) { 
    yield put(profileError(error?.response?.data?.message));
  }
}
export function* watchProfile() {
  yield takeEvery(EDIT_PROFILE, editProfile)
}

function* ProfileSaga() {
  yield all([fork(watchProfile)])
}

export default ProfileSaga
